<template>
	<dl>
		<div v-for="qa in blok.items" :key="qa._uid" class="mb-4">
			<v-storyblok-component :is="qa.component" :blok="qa" />
		</div>
	</dl>
</template>

<script setup lang="ts">
import type {BlokComponent} from "@pkg/shared/types";

defineProps<{
	blok: Extract<BlokComponent, {component: "sb-faq-section"}>;
}>();
</script>
